import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import navigator from '../../../services/ui/navigator';

const AppContainer = ({ children, history }) => {
    navigator.setNavigator(history);
    return <div>{children}</div>;
};

export default connect(null, null)(withRouter(AppContainer));
